import { Col, Modal, Row, Typography } from 'antd'
import DocViewer from 'react-doc-viewer'
import styled from 'styled-components'
import { COLORS } from 'theme'
import Button from '../../../../components/Button'
import Flex from '../../../../components/Flex'
export const LeftDiv = styled.div`
  min-width: 20%;
`
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 142px);
  width: 100%;
  border: 1px solid ${COLORS.PAGE_BORDER};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
`
export const StickyLeftDiv = styled.div`
  position: sticky;
  top: 30px;
`
export const StickyRightDiv = styled.div``
export const StickyQualificationRightDiv = styled.div``
export const RightDiv = styled.div`
  width: 70%;
  padding: 0px 5px 200px 5px;
  overflow-x: hidden;
  overflow-y: auto;
  min-height: 69vh;
  position: relative;
  &::-webkit-scrollbar {
    display: none;
  }
`
export const Container = styled(Flex)`
  padding: 30px 25px 0px 25px;
  gap: 5%;
  background-color: white;
`
export const MainWrapper = styled(Flex)`
  width: 100%;
  gap: 10px;
  height: 100%;
  overflow-y: scroll;

  ${props =>
    props.preventScroll &&
    css`
      overflow: hidden;
    `}
`

export const LastDiv = styled.div`
  width: ${props => (props.code === '3' ? '0%' : '30%')};
  position: sticky;
  top: 30px;
  height: fit-content;
  margin-bottom: 1rem;
`

export const ContinueManualBtn = styled(Button.Outline)(({ disabled }) => ({
  border: '1px solid rgba(227, 222, 255, 1)',
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  padding: '9px, 20px, 9px, 20px',
  borderRadius: '10px',
  color: disabled ? 'rgba(209, 213, 219, 1)' : 'rgba(50, 73, 215, 1);',
  height: 50,
  background: 'rgba(251, 250, 255, 1)',
  '&:hover': {
    background: '#FFFFFF',
    border: '1px solid rgba(227, 222, 255, 1)',
    color: disabled ? 'rgba(209, 213, 219, 1)' : 'rgba(50, 73, 215, 1);',
  },
  ' &:focus': {
    background: '#FFFFFF',
    border: '1px solid rgba(227, 222, 255, 1)',
    color: disabled ? 'rgba(209, 213, 219, 1)' : 'rgba(50, 73, 215, 1);',
  },
}))

export const StyledDialog = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
    height: 535px;
    display: flex;
    justify-content: center;
    align-items: center;
    // width: 1015px;
  }
  .ant-modal {
    width: 1015px;
  }
  .ant-modal-body {
    width: 100%;
    height: 100%;
  }
`

export const ScrollableBox = styled.div`
  width: 920px;
  height: 327px;
  overflow-y: ${props => (props.type === 'pdf' ? 'auto' : 'hidden')};
  border: 1px solid rgba(189, 189, 189, 1);
`

export const PDFImageElement = styled.img`
  max-width: 100%;
  height: auto;
  margin-bottom: 10px;
`

export const StyledDocViewer = styled(DocViewer)(() => ({
  width: '920px',
  height: '327px',
  // border: '1px 0px 0px 0px',
  // overflowY: 'auto',
  '#header-bar': {
    display: 'none',
  },
}))

export const FileDisplaySection = styled('div')(({ spacing }) => ({
  border: '1px solid rgba(50, 73, 215, 1)',
  background: 'rgba(250, 250, 251, 1)',
  height: '44px',
  display: 'flex',
  justifyContent: 'space-between',
  padding: spacing ? '10px 22px' : '5px',
  borderRadius: '8px',
  alignItems: 'center',
}))

export const FileNameText = styled.div`
  color: rgba(50, 53, 56, 1);
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-weight: 500;
`

export const FileSizeText = styled.div`
  color: rgba(50, 53, 56, 1);
  font-family: Plus Jakarta Sans;
  font-size: 10px;
  font-weight: 500;
`

export const FileContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 7px;
`
export const IconContainer = styled.div`
  background: rgba(236, 236, 236, 1);
  display: flex;
  align-items: center;
  height: 36px;
  width: 40px;
  justify-content: center;
  border-radius: 5px;
  cursor: pointer;
`
export const SpaceBetweenRow = styled(Row)(() => ({
  justifyContent: 'space-between',
}))

export const EndColElement = styled(Col)(() => ({
  justifyContent: 'flex-end',
  display: 'flex',
  alignItems: 'center',
}))

export const AppTypography = styled(Typography)(() => ({
  fontSize: 16,
  fontWeight: 400,
}))

export const HeaderComponent = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '2rem',
  justifyContent: 'flex-start',
}))

export const ModalContainer = styled('div')(() => ({
  display: 'flex',
  height: '100%',
  flexDirection: 'column',
}))

export const ModalContentContainer = styled('div')(() => ({
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
}))
